import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import { defaultValidateMessages } from "./Helper";
import {
  Form,
  Col,
  Row,
  Button,
  Select,
  Input,
  InputNumber,
  Space,
  Table,
  Empty,
  message,
  Popconfirm,
  Checkbox,
  notification,
  Tooltip,
  Switch,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  EditOutlined,
  QuestionCircleOutlined,
  CheckCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { ColumnHelper } from "util/TableHelper";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};
const QuestionMarkToolTip = ({ tooltip }) => {
  return (
    <Tooltip title={tooltip}>
      <QuestionCircleOutlined
        className="gx-text-blue"
        style={{ marginRight: 10 }}
      />
    </Tooltip>
  );
};

const PaymentSetUpdateForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [posCommissions, setPosCommissions] = useState([]);
  const [selectedPosCommission, setSelectedPosCommission] = useState(JSON);
  const [selectedPosCommissionId, setSelectedPosCommissionId] = useState(null);
  const [hiddenFields, setHiddenFields] = useState([]);
  const [hiddenCheckboxFields, setHiddenCheckboxFields] = useState([]);
  const [commissionPlaceHolders, setCommissionPlaceHolders] = useState({
    data: [],
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
    activeTab: 0,
  });
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: false,
  });
  const [clickEditDisabled, setClickEditDisabled] = useState(false);

  const commissionInputProps = {
    style: { width: "calc(100% - 35px)" },
    min: 0,
    max: 100,
    decimalSeparator: ",",
    precision: 2,
  };

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }

    RequestHandler.get(
      `/PosCollection/CommissionOptions?requestForNoPayment=true&usePassiveBankInfoCommissions=true`
    ).then((response) => {
      setPosCommissions(response.data.commissions);
    });

    if (props.data.paymentSetBankInfos) {
      setTableData({
        data: props.data.paymentSetBankInfos,
        loading: false,
        total: props.data.paymentSetBankInfos.length,
      });
    }
  }, [props.data]);

  const onSuccess = () => {
    form.resetFields();
    if (props.onSuccess) props.onSuccess();
  };

  const onFinish = (values) => {
    if (tableData.total === 0) {
      tableDataError("error");
      setLoading(false);
      return;
    }
    values.banks = tableData.data;
    RequestHandler.put(`/PaymentSet`, values).then((response) => {
      setLoading(false);
      if (response?.success) {
        form.resetFields();
        onSuccess();
      }
      setLoading(false);
    });
  };

  const tableDataError = (type) => {
    notification[type]({
      message: "HATA",
      description: "Lütfen tabloya kayıt ekleyin.",
      duration: 4,
    });
  };

  const renderInstallmentInput = (installmentCount) => {
    const fieldName = `placeHoldercommissionRate${installmentCount}`;
    return (
      <Input.Group compact>
        <Col span={16}>
          <Form.Item
            label={
              installmentCount === 1
                ? "Tek Çekim"
                : installmentCount + " Taksit"
            }
            name={"commissionRate" + installmentCount}
            hidden={hiddenFields.includes("commissionRate" + installmentCount)}
          >
            <InputNumber
              {...commissionInputProps}
              name={"commissionRate" + installmentCount}
              placeholder={
                commissionPlaceHolders.data[installmentCount - 1]?.[fieldName] // İndeksler 0'dan başladığı için 1 çıkarıyoruz
                  ? commissionPlaceHolders.data[installmentCount - 1]?.[
                      fieldName
                    ]
                  : "Komisyon Oranı"
              }
              style={{ width: "100%" }}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
            />
          </Form.Item>
        </Col>
        <Col
          span={6}
          hidden={hiddenCheckboxFields.includes(
            "isInstallmentActive" + installmentCount
          )}
          // style={{ marginTop: "2%" }}
        >
          <div
            style={{
              flexDirection: "column",
              // marginLeft: "14%",
            }}
          >
            <Form.Item
              noStyle
              valuePropName="checked"
              name={"isInstallmentActive" + installmentCount}
            >
              <Checkbox name={"isInstallmentActive" + installmentCount}>
                Aktif
              </Checkbox>
            </Form.Item>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "3%",
              }}
            >
              <Form.Item
                noStyle
                valuePropName="checked"
                name={"isCommissionIncludedCommissionRate" + installmentCount}
              >
                <Checkbox name="KTD">KTD</Checkbox>
              </Form.Item>
              <QuestionMarkToolTip
                tooltip={
                  <>
                    <p>
                      <strong>Komisyon Tutara Dahil:</strong>
                      <ul>
                        <li>
                          Bu seçenek aktif edilir ise komisyon tutarı tuşlanan
                          tutarın içine dahil edilir ve kullanıcıya bu yönde
                          bilgi gösterilir.
                        </li>
                        <li>
                          KTD değeri ile ilgili herhangi bir değişiklik yapılmaz
                          ise, bu seçenek ilgili banka taksit tanımında nasıl
                          işaretlenmişse o şekilde işlem yapılır.
                        </li>
                      </ul>
                    </p>
                  </>
                }
              />
            </div>
          </div>
        </Col>
      </Input.Group>
    );
  };

  const onChangePosCommission = (e) => {
    form.resetFields([
      "commissionRate1",
      "commissionRate2",
      "commissionRate3",
      "commissionRate4",
      "commissionRate5",
      "commissionRate6",
      "commissionRate7",
      "commissionRate8",
      "commissionRate9",
      "commissionRate10",
      "commissionRate11",
      "commissionRate12",
      "isInstallmentActive1",
      "isInstallmentActive2",
      "isInstallmentActive3",
      "isInstallmentActive4",
      "isInstallmentActive5",
      "isInstallmentActive6",
      "isInstallmentActive7",
      "isInstallmentActive8",
      "isInstallmentActive9",
      "isInstallmentActive10",
      "isInstallmentActive11",
      "isInstallmentActive12",
    ]);
    setHiddenFields([]);
    setHiddenCheckboxFields([]);
    setCommissionPlaceHolders({
      data: [],
    });
    setPlaceHoldersFromCommission({
      data: [],
    });
    setSelectedPosCommissionId(e);
    var selectedCommission = posCommissions.find((x) => x.id === e);
    if (selectedCommission !== null && selectedCommission !== undefined) {
      setSelectedPosCommission(selectedCommission);
      setPlaceHoldersFromCommission(selectedCommission);
    }
  };

  const setCommissionRatesToFormValues = () => {
    // selectedPosCommission içindeki verileri kontrol et
    Object.keys(selectedPosCommission)
      .filter((x) => x.startsWith("commissionRate") && !x.endsWith("Enabled"))
      .forEach((rate, i) => {
        const commissionRate = selectedPosCommission[rate];
        const number = i + 1; // Doğru numarayı almak için
        const isComissionIncluded =
          selectedPosCommission["isCommissionIncludedCommissionRate" + number];

        if (commissionRate === null) {
          toggleFieldVisibility(rate);
          toggleFieldCheckboxVisibility("isInstallmentActive" + number);
        } else {
          // Formu güncelle
          form.setFieldsValue({
            [rate]: commissionRate, // Komisyon oranını set et
            [`isInstallmentActive${number}`]: true, // Checkbox'ı işaretle
            [`isCommissionIncludedCommissionRate${number}`]:
              isComissionIncluded ?? false,
          });
        }
      });

    setCommissionPlaceHolders({ data: [] }); // Placeholders'ı temizle
  };

  const setCommissionRatesToFormValuesWithCommission = (commission) => {
    // selectedPosCommission içindeki verileri kontrol et
    Object.keys(commission)
      .filter((x) => x.startsWith("commissionRate") && !x.endsWith("Enabled"))
      .forEach((rate, i) => {
        const commissionRate = commission[rate];
        const number = i + 1; // Doğru numarayı almak için
        const isComissionIncluded =
          commission["isCommissionIncludedCommissionRate" + number];

        if (commissionRate === null) {
          toggleFieldVisibility(rate);
          toggleFieldCheckboxVisibility("isInstallmentActive" + number);
        } else {
          // Formu güncelle
          form.setFieldsValue({
            [rate]: commissionRate, // Komisyon oranını set et
            [`isInstallmentActive${number}`]: true, // Checkbox'ı işaretle
            [`isCommissionIncludedCommissionRate${number}`]:
              isComissionIncluded ?? false,
          });
        }
      });

    setCommissionPlaceHolders({ data: [] }); // Placeholders'ı temizle
  };

  const setPlaceHoldersFromCommission = (commission) => {
    let data = [];
    {
      Object.keys(commission)
        .filter((x) => x.startsWith("commissionRate") && !x.endsWith("Enabled"))
        .map((rate, i) => {
          const commissionRate = commission[rate];
          var renderedData = renderCommissionRateData(commissionRate);

          const newData = { ["placeHolder" + rate]: renderedData };
          data.push(newData);
        });
    }
    setCommissionPlaceHolders({
      data: data,
    });
  };

  const clearCommissionRates = () => {
    setSelectedPosCommissionId(null);
    setHiddenFields([]);
    setHiddenCheckboxFields([]);
    form.resetFields([
      "commissionRate1",
      "commissionRate2",
      "commissionRate3",
      "commissionRate4",
      "commissionRate5",
      "commissionRate6",
      "commissionRate7",
      "commissionRate8",
      "commissionRate9",
      "commissionRate10",
      "commissionRate11",
      "commissionRate12",
      "isInstallmentActive1",
      "isInstallmentActive2",
      "isInstallmentActive3",
      "isInstallmentActive4",
      "isInstallmentActive5",
      "isInstallmentActive6",
      "isInstallmentActive7",
      "isInstallmentActive8",
      "isInstallmentActive9",
      "isInstallmentActive10",
      "isInstallmentActive11",
      "isInstallmentActive12",
      "selectedPosCommissionDefinitionId",
      "isCommissionIncludedCommissionRate1",
      "isCommissionIncludedCommissionRate2",
      "isCommissionIncludedCommissionRate3",
      "isCommissionIncludedCommissionRate4",
      "isCommissionIncludedCommissionRate5",
      "isCommissionIncludedCommissionRate6",
      "isCommissionIncludedCommissionRate7",
      "isCommissionIncludedCommissionRate8",
      "isCommissionIncludedCommissionRate9",
      "isCommissionIncludedCommissionRate10",
      "isCommissionIncludedCommissionRate11",
      "isCommissionIncludedCommissionRate12",
    ]);

    setCommissionPlaceHolders({
      data: [],
    });
    setClickEditDisabled(false);
  };

  const toggleFieldVisibility = (field) => {
    setHiddenFields(
      (prevHiddenFields) =>
        prevHiddenFields.includes(field)
          ? prevHiddenFields.filter((f) => f !== field) // Alan varsa çıkar
          : [...prevHiddenFields, field] // Alan yoksa ekle
    );
  };
  const toggleFieldCheckboxVisibility = (field) => {
    setHiddenCheckboxFields(
      (prevHiddenCheckboxFields) =>
        prevHiddenCheckboxFields.includes(field)
          ? prevHiddenCheckboxFields.filter((f) => f !== field) // Alan varsa çıkar
          : [...prevHiddenCheckboxFields, field] // Alan yoksa ekle
    );
  };

  //#region  Table

  const renderCommissionRate = (data, record, includedKey) => {
    return data || data === 0 ? (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 4,
          marginLeft: "10px",
        }}
      >
        {ColumnHelper.renderDecimal(data)}
        {record[includedKey] && (
          <Tooltip title="KTD">
            <CheckCircleOutlined style={{ color: "#1890ff" }} />
          </Tooltip>
        )}
      </div>
    ) : (
      "-"
    );
  };

  const renderCommissionRateData = (data) =>
    data || data === 0 ? ColumnHelper.renderDecimal(data) : "-";

  const columns = [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      key: "bankLogo",
      width: "8%",
      render: (data) => <img src={data}></img>,
    },
    {
      title: "Kart", // Buraya kart logo indexi gelecek
      dataIndex: "cardLogo",
      key: "cardLogo",
      width: "8%",
      render: (data, row) =>
        row.bankId === 889 || row.bankId === 890 ? (
          row.cardLogo === null ? (
            <p style={{ paddingTop: "inherit" }}>{row.cardName}</p>
          ) : (
            <img src={data} height={35} width={102}></img>
          )
        ) : (
          <img src={data}></img>
        ),
    },
    {
      title: "Banka Erişimi",
      dataIndex: "posCollectionBankInfoName",
      key: "posCollectionBankInfoName",
      width: "8%",
    },
    {
      title: "Tek Çekim",
      dataIndex: "commissionRate1",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate1"
        ),
    },
    {
      title: "2 Taksit",
      dataIndex: "commissionRate2",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate2"
        ),
    },
    {
      title: "3 Taksit",
      dataIndex: "commissionRate3",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate3"
        ),
    },
    {
      title: "4 Taksit",
      dataIndex: "commissionRate4",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate4"
        ),
    },
    {
      title: "5 Taksit",
      dataIndex: "commissionRate5",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate5"
        ),
    },
    {
      title: "6 Taksit",
      dataIndex: "commissionRate6",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate6"
        ),
    },
    {
      title: "7 Taksit",
      dataIndex: "commissionRate7",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate7"
        ),
    },
    {
      title: "8 Taksit",
      dataIndex: "commissionRate8",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate8"
        ),
    },
    {
      title: "9 Taksit",
      dataIndex: "commissionRate9",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate9"
        ),
    },
    {
      title: "10 Taksit",
      dataIndex: "commissionRate10",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate10"
        ),
    },
    {
      title: "11 Taksit",
      dataIndex: "commissionRate11",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate11"
        ),
    },
    {
      title: "12 Taksit",
      dataIndex: "commissionRate12",
      align: "center",
      render: (data, record) =>
        renderCommissionRate(
          data,
          record,
          "isCommissionIncludedCommissionRate12"
        ),
    },
    {
      title: "Düzenle",
      dataIndex: "id",
      width: "1%",
      align: "center",
      render: (data, row) => (
        <Popconfirm
          title="Düzenlemek istiyor musunuz?"
          okText="Evet"
          cancelText="Hayır"
          onConfirm={() => handleOnClickEditFromTable(data)}
          disabled={clickEditDisabled}
        >
          <a>
            <EditOutlined style={{ color: "orange" }} />
          </a>
        </Popconfirm>
      ),
    },
    {
      title: "Sil",
      dataIndex: "id",
      width: "1%",
      align: "center",
      render: (data, row) => (
        <Popconfirm
          title="Silmek istiyor musunuz?"
          okText="Evet"
          cancelText="Hayır"
          onConfirm={() => handleOnClickRemoveFromTable(data)}
        >
          <a>
            <DeleteOutlined style={{ color: "red" }} />
          </a>
        </Popconfirm>
      ),
    },
  ];

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const addToTable = () => {
    const isDuplicate = tableData.data.some(
      (item) =>
        item.id === selectedPosCommission.id ||
        item.posCollectionCommissionDefinitionId === selectedPosCommission.id ||
        (item.posCollectionBankInfoId !==
          selectedPosCommission.posCollectionBankInfoId &&
          item.bankId === selectedPosCommission.bankId)
    );

    if (isDuplicate) {
      message.warning(
        "Aynı kaydı veya aynı bankanın farklı banka erişim bilgilerine ait kaydı  ekleyemezsiniz."
      );
      return; // Aynı id'li veri varsa ekleme işlemini durdur
    }

    if (!selectedPosCommission || selectedPosCommissionId === null) {
      message.warning("Lütfen banka taksit tanımı seçin.");
      return; // Aynı id'li veri varsa ekleme işlemini durdur
    }
    // Formdaki tüm değerleri al
    const formValues = form.getFieldsValue();

    // commissionRate1'den commissionRate12'ye kadar olanları kontrol et
    let hasChanges = false; // Değişiklik yapıp yapmadığımızı kontrol edeceğiz
    const updatedCommission = { ...selectedPosCommission }; // Mevcut JSON'u klonla
    const defaultCommission = { ...selectedPosCommission };

    if (posCommissions.some((x) => x.id === selectedPosCommission.id)) {
      updatedCommission.posCollectionCommissionDefinitionId =
        selectedPosCommission.id;
      defaultCommission.posCollectionCommissionDefinitionId =
        selectedPosCommission.id;
    }

    // Tüm form alanlarının null veya undefined olup olmadığını kontrol et
    let allFieldsAreNull = true;
    let allCheckBoxFieldFalse = true;

    for (let i = 1; i <= 12; i++) {
      let isInstallmentActiveFieldName = `isInstallmentActive${i}`;
      let fieldValue = formValues[isInstallmentActiveFieldName];
      if (fieldValue === undefined || fieldValue === false) {
        fieldValue = false;
        form.setFieldsValue({ [isInstallmentActiveFieldName]: fieldValue });
      } else {
        allCheckBoxFieldFalse = false;
      }
    }

    if (allCheckBoxFieldFalse === true) {
      message.warning("Aktif olacak taksitleri işaretleyiniz.");
      return; // Aynı id'li veri varsa ekleme işlemini durdur
    }

    for (let i = 1; i <= 12; i++) {
      const fieldName = `commissionRate${i}`;
      let fieldValue = formValues[fieldName];
      let isInstallmentActiveFieldName = `isInstallmentActive${i}`;
      let isInstallmentActiveFieldValue =
        formValues[isInstallmentActiveFieldName];

      if (isInstallmentActiveFieldValue === true) {
        if (fieldValue === null || fieldValue === undefined) {
          updatedCommission[fieldName] = defaultCommission[fieldName];
          hasChanges = true;
          continue; // Değişiklik tespit edildi
        }
      }
      // Eğer form alanı undefined ise null yap
      if (fieldValue === undefined) {
        fieldValue = null;
      }

      // Eğer form alanı null değilse, tüm alanlar null değil demektir
      if (fieldValue !== null) {
        allFieldsAreNull = false;
      }

      if (isInstallmentActiveFieldValue !== true) {
        fieldValue = null;
        updatedCommission[fieldName] = fieldValue;
        hasChanges = true;
        continue;
      }

      // Eğer selectedPosCommission'daki değer form'daki değerden farklıysa değişiklik var
      if (updatedCommission[fieldName] !== fieldValue) {
        updatedCommission[fieldName] = fieldValue;
        hasChanges = true; // Değişiklik tespit edildi
      }
    }

    // Eğer tüm alanlar null ise, selectedPosCommission'ı ekle
    if (allFieldsAreNull && hasChanges === false) {
      // Burda KTD değerini mapleyeceğiz.
      for (let i = 1; i <= 12; i++) {
        let isCommissionIncludedCommissionRateFieldName = `isCommissionIncludedCommissionRate${i}`;
        let isCommissionIncludedCommissionRateFieldValue =
          formValues[isCommissionIncludedCommissionRateFieldName];
        if (
          isCommissionIncludedCommissionRateFieldValue !== undefined &&
          isCommissionIncludedCommissionRateFieldValue !== null
        ) {
          defaultCommission[isCommissionIncludedCommissionRateFieldName] =
            isCommissionIncludedCommissionRateFieldValue;
        }
      }

      setTableData((prevTableData) => ({
        ...prevTableData,
        data: [...prevTableData.data, defaultCommission], // Seçilen şeyi ekle
        loading: false,
        total: prevTableData.total + 1,
      }));
      setClickEditDisabled(false);
      return;
    } else {
      // Burda KTD değerini mapleyeceğiz.
      for (let i = 1; i <= 12; i++) {
        let isCommissionIncludedCommissionRateFieldName = `isCommissionIncludedCommissionRate${i}`;
        let isCommissionIncludedCommissionRateFieldValue =
          formValues[isCommissionIncludedCommissionRateFieldName];
        if (
          isCommissionIncludedCommissionRateFieldValue === undefined ||
          isCommissionIncludedCommissionRateFieldValue === null
        ) {
          updatedCommission[isCommissionIncludedCommissionRateFieldName] =
            defaultCommission[isCommissionIncludedCommissionRateFieldName];
        } else {
          updatedCommission[isCommissionIncludedCommissionRateFieldName] =
            isCommissionIncludedCommissionRateFieldValue;
        }
      }

      setTableData((prevTableData) => ({
        ...prevTableData,
        data: [...prevTableData.data, updatedCommission], // Güncellenen veriyi ekle
        loading: false,
        total: prevTableData.total + 1,
      }));
      setClickEditDisabled(false);
    }

    clearCommissionRates();
  };

  const handleOnClickRemoveFromTable = (id) => {
    var data = tableData.data.filter((x) => x.id !== id);
    setTableData((prevTableData) => ({
      ...prevTableData,
      data: data, // Seçilen şeyi ekle
      loading: false,
      total: prevTableData.total - 1,
    }));
  };

  const handleOnClickEditFromTable = (id) => {
    var data = tableData.data.find((x) => x.id === id);
    setPlaceHoldersFromCommission({
      data: [],
    });
    if (
      posCommissions.some(
        (x) => x.id === data.posCollectionCommissionDefinitionId
      )
    ) {
      setSelectedPosCommissionId(data.posCollectionCommissionDefinitionId);
      form.setFieldsValue({
        selectedPosCommissionDefinitionId:
          data.posCollectionCommissionDefinitionId,
      });
    } else {
      setSelectedPosCommissionId(data.id);
      form.setFieldsValue({
        selectedPosCommissionDefinitionId: data.id,
      });
    }

    setSelectedPosCommission(data);
    setCommissionRatesToFormValuesWithCommission(data);
    var remainingData = tableData.data.filter((x) => x.id !== id);
    setTableData((prevTableData) => ({
      ...prevTableData,
      data: remainingData, // Seçilen şeyi ekle
      loading: false,
      total: prevTableData.total - 1,
    }));
    setClickEditDisabled(true);
  };
  //#endregion

  return (
    <>
      <Form
        {...formItemLayout}
        validateMessages={defaultValidateMessages}
        form={form}
        name="paymentSetUpdate"
        onFinish={onFinish}
        onFinishFailed={() => setLoading(false)}
      >
        <Row style={{ marginRight: "33%" }}>
          <Col span={12}>
            <Form.Item name="id" hidden>
              <Input />
            </Form.Item>
            <Form.Item
              label="Ödeme Seti Adı"
              name="name"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={
                <span>
                  Varsayılan Yap{" "}
                  <Tooltip
                    title={
                      <>
                        <p>
                          <strong>Seçenek aktif edilirse:</strong>
                          <ul>
                            <li>Üyeliksiz Ödeme ekranında kullanılır.</li>
                          </ul>
                        </p>
                      </>
                    }
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Tooltip>
                </span>
              }
              name="isDefault"
              valuePropName="checked"
              style={{ marginBottom: 0 }}
            >
              <Switch />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={8}>
            <Form.Item
              label={"Banka Taksit Tanımı"}
              required={true}
              name={"selectedPosCommissionDefinitionId"}
            >
              <Select
                allowClear
                showSearch
                placeholder="Banka Taksit Tanımı seçiniz."
                filterOption={(input, option) =>
                  option.children
                    .toLocaleLowerCase("tr-TR")
                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                }
                onChange={onChangePosCommission}
                value={selectedPosCommissionId}
              >
                {posCommissions.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.bankName +
                      " (" +
                      item.cardName +
                      ")" +
                      (item.posCollectionBankInfoName
                        ? " (" + item.posCollectionBankInfoName + ")"
                        : "")}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label={"Seçenekler"}>
              <Space>
                <Button
                  onClick={setCommissionRatesToFormValues}
                  disabled={selectedPosCommission === null}
                >
                  Komisyonları Uygula
                </Button>
                <Button onClick={clearCommissionRates}>Oranları Temizle</Button>
              </Space>
            </Form.Item>

            {renderInstallmentInput(1)}
            {renderInstallmentInput(2)}
            {renderInstallmentInput(3)}
            {renderInstallmentInput(4)}
            {renderInstallmentInput(5)}
            {renderInstallmentInput(6)}
            {renderInstallmentInput(7)}
            {renderInstallmentInput(8)}
            {renderInstallmentInput(9)}
            {renderInstallmentInput(10)}
            {renderInstallmentInput(11)}
            {renderInstallmentInput(12)}
            <Col span={24} style={{ textAlign: "end" }}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => addToTable()}
                loading={loading}
              >
                Tabloya Ekle
              </Button>
            </Col>
          </Col>

          <Col span={16}>
            <Table
              columns={columns}
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Veri Yok"
                  />
                ),
              }}
              style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
              rowKey="id"
              filterable={true}
              sortable={true}
              pageable={true}
              onChange={paging}
              pagination={{
                defaultPageSize: tableDataQueryOptions.take,
                pageSizeOptions: ["15", "25", "50", "100"],
                total: tableData.total,
                current: tableDataQueryOptions.current,
              }}
              dataSource={tableData.data}
              loading={tableData.loading}
              size="small"
            />
          </Col>
        </Row>
        <Row justify="space-between">
          <Col></Col>
          <Col>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              htmlType="submit"
              onClick={() => setLoading(true)}
              loading={loading}
            >
              Güncelle
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};
export default PaymentSetUpdateForm;
